import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderItemEntity } from '../../domain/entities/OrderItemEntity'
import type { OrderItemAdminDto } from '@/backend/market'

export class OrderItemModel extends OrderItemEntity {
  constructor(dataDto: OrderItemAdminDto) {
    super()

    mapEntityProperties<OrderItemEntity>(this, dataDto, {
      map: {
        itemName: dataDto.item?.name,
        itemImgUrl: dataDto.item?.imageUrl,
        totalPrice: (dataDto.quantity ?? 0) *
         (((dataDto.unitPrice ?? 0) + (dataDto.selectionAdditionalPrice ?? 0)
          - (dataDto.selectionAdditionalPriceDiscountAmount ?? 0)) - (dataDto.discountAmount ?? 0)),
        maxQuantityPerOrder: dataDto.item?.maxQuantityPerOrder,
        inventoryQuantity: dataDto.item?.inventoryQuantity
      }
    })
  }
}
